
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Etablissement from '@/extend/classes/Etablissement';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeEtablissement' })

export default class storeEtablissement extends VuexModule {
  // States
  private reccords: Etablissement[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get etablissementLoading (): boolean {
    return this.dataLoading;
  }
  private get etablissementRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get etablissementLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewEtablissement() {
    return (): Etablissement => { 
      return this.getEtablissement(0, true);
    }
  }

  
  public get getEtablissement () {
    return (id: number, canCreate = false): Etablissement => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Etablissement can't be 0")
        return new Etablissement();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Etablissement();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Etablissement.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromEtablissement(data.reccords[0] as Etablissement);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listEtablissement (): Etablissement[] {
    return this.reccords;
  }

  public get listConfigEtablissement (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mEtablissementRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mEtablissementClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mEtablissementLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mEtablissementLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Etablissement.fromJson(reccord as Etablissement));
    })
    Etablissement.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mEtablissementConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mEtablissementCreated (obj: Etablissement): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareEtablissement(obj)) {
          api.fromEtablissement(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareEtablissement(obj)) {
            api.fromEtablissement(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mEtablissementUpdated (obj: Etablissement): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareEtablissement(obj)) {
          api.fromEtablissement(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mEtablissementDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerEtablissement (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.etablissementRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerEtablissement(this.etablissementCreated, this.etablissementUpdated, this.etablissementDeleted);
          this.mEtablissementRegistered();
        } else {
          setTimeout(() => resolve(this.registerEtablissement(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.etablissementLoading && !this.etablissementLoaded) {
          this.mEtablissementLoading(true);
          return Etablissement.list(filter)
            .then((data: ListData) => {
              this.mEtablissementLoaded(data);
              this.mEtablissementLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredEtablissement (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.etablissementLoading) {
        this.mEtablissementLoading(true);
        return Etablissement.list(filter)
          .then((data: ListData) => {
            this.mEtablissementLoaded(data);
            this.mEtablissementLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createEtablissement (obj: Etablissement): Promise<Etablissement> {
    return new Promise((resolve, reject) => {
      return Etablissement.fromJson(obj).createForStoreEtablissement()
        .then((reccords) => {
          this.mEtablissementCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateEtablissement (obj: Etablissement): Promise<Etablissement> {
    return new Promise((resolve, reject) => {
      return Etablissement.fromJson(obj).updateForStoreEtablissement()
        .then((reccords) => {
          this.mEtablissementUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteEtablissement (obj: Etablissement): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Etablissement.fromJson(obj).deleteForStoreEtablissement()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mEtablissementDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private etablissementCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mEtablissementConfigUpdated(config)
    const obj = objConfig.obj as Etablissement;
    this.mEtablissementCreated(Etablissement.fromJson(obj));
  }

  @Action
  private etablissementUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mEtablissementConfigUpdated(config)
    const obj = objConfig.obj as Etablissement;
    this.mEtablissementUpdated(Etablissement.fromJson(obj));
  }

  @Action
  private etablissementDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Etablissement;
    this.mEtablissementDeleted(obj.id);
  }
}
